import Layout from '../Layout'
import Carousel from '../../components/Carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import styles from './styles.module.css'
import SegmentCard from '../../components/SegmentCard'
import Motocycle from '../../assets/motocycle.png'
import Car from '../../assets/car.png'
import StepByStep from '../../components/StepByStep'

function Landing () {
  return (
    <Layout>
      <div className={styles.contentContainer}>
        <section>
          <div className={styles.introductionContainer}>
            <div>
              <h6>Totalmente digital</h6>
              <h1>Seu novo jeito de fazer consórcio.</h1>
            </div>
            <p>
              O guerra digital é a nova plataforma de consórcio feita sobre
              medida para você. Simule agora e encontre o melhor valor para seu
              negócio.
            </p>
          </div>
          <div className={styles.carouselContainer}>
            <Carousel />
          </div>
        </section>
        <section>
          <h3 className={styles.simulationTitle}>Simulação</h3>
          <div className={styles.segmentsContainer}>
            <SegmentCard
              img={Car}
              segmentId={'AU'}
              segmentName={'Automóveis'}
            />
            {/* <SegmentCard img={Motocycle} segmentId={"AI"} segmentName={"Automóveis - IPCA"}/> */}
            {/* <SegmentCard img={Motocycle} segmentId={"EE"} segmentName={"Eletroeletrônicos"}/> */}
            {/* <SegmentCard img={Motocycle} segmentId={"IM"} segmentName={"Imóveis"}/> */}
            <SegmentCard
              img={Motocycle}
              segmentId={'MO'}
              segmentName={'Motocicletas'}
            />
            {/* <SegmentCard img={Motocycle} segmentId={"SV"} segmentName={"Serviços"}/> */}
            {/* <SegmentCard img={Motocycle} segmentId={"TC"} segmentName={"Tratores e Caminhões (Pesados)"}/> */}
          </div>
        </section>
       <StepByStep />
      </div>
    </Layout>
  )
}

export default Landing
